<template>
  <div class="wrap-box">
    <div class="top-box">
      <div class="content-box">
        <!-- 取消类型 -->
        <div class="card-box card-padding">
          <div class="card-title card-title-flex">
            <div class="">
              <span>取消类型</span>
            </div>
          </div>
          <div class="radio-box">
            <van-radio-group
              v-model="dataForm.cancelType"
              direction="horizontal"
              @change="cancelTypeChange"
            >
              <van-radio
                v-for="(item, index) in cancelTypeList"
                :key="index"
                :name="item.key"
              >{{ item.value }}</van-radio>
            </van-radio-group>
          </div>
          <div class="remark-box">
            <div class="remark-tips">备注：请与客户协商后再取消订单！</div>
            <div class="remark-content">
              <span>已联系客户{{ countObj.allContactCount }}次，有效接通记录</span>
              <span class="color-orange">{{ countObj.successContactCount }}次</span>
            </div>
          </div>
        </div>
        <!-- 取消原因 -->
        <div class="card-box card-padding">
          <div class="card-title card-title-flex">
            <div class="">
              <span>取消原因</span>
              <span class="card-tips card-tips__red">（必填）</span>
            </div>
          </div>
          <van-divider style="margin: 16px -16px;" />
          <CancelReasonSelectBox
            ref="cancelReasonSelectBox"
            title="请选择对应的取消原因"
            :data-list="reasonDataList"
            :value.sync="dataForm.cancelReason"
            placeholder="请输入取消原因"
            :maxlength="255"
          />
        </div>
        <!-- 取消照片详情 -->
        <template
          v-if="isCancelFee"
        >
          <!-- 电子工单 -->
          <!-- <div
            class="card-box card-padding"
          >
            <div
              class="card-title card-title-flex"
              @click="goWorkOrders"
            >
              <div
                class="card-flex"
              >
                <img
                  class="takeImg"
                  src="@/assets/img/take_photo.png"
                  alt=""
                >电子工单
              </div>
              <div>
                <span
                  class="stateInfo"
                  :class="{ isStateInfo: !isPerfection}"
                >{{ isPerfection ? '已完善' : '未完善' }}</span>
                <van-icon name="arrow" />
              </div>
            </div>
          </div> -->
          <div
            class="card-box"
          >
            <WorkOrders
              v-if="taskNo"
              :order-no="orderNo"
              :task-no="taskNo"
              :hidden-customer-sign="true"
              :hidden-pick-up-person-sign="true"
              @clickHandler="setCurrentScrollTop"
            />
          </div>
          <div
            class="card-box card-padding"
          >
            <div
              class="card-title card-title-flex"
            >
              <div class="">
                <span>取消照片详情</span>
                <!-- <span class="card-tips card-tips__red">（缺失{{ (imageInfo.photoNumAll || 0)-(imageInfo.photoNumTaked || 0) }}张照片）</span> -->
              </div>
              <!-- <div class="card-title-info">
                <span>{{ imageInfo.photoNumTaked || 0 }}/{{ imageInfo.photoNumAll || 0 }}</span>
                <van-icon name="arrow" />
              </div> -->
            </div>
            <van-divider
              style="margin: 16px -16px;"
            />
            <!-- <van-button
              type="info"
              size="large"
              @click="toPhoto"
            >去拍照</van-button> -->
            <Certificate
              v-if="taskNo"
              :photo-params="photoParams"
              @uploadCompleted="checkPictureNum"
            />
          </div>
        </template>
        <!-- 确认弹窗 -->
        <ConfirmDialog
          ref="confirmDialog"
        />
      </div>
    </div>
    <div class="btn-box">
      <!-- 底部按钮 -->
      <van-row gutter="17">
        <van-col span="12">
          <van-button
            type="default"
            block
            plain
            @click="backToWork"
          >继续作业</van-button>
        </van-col>
        <van-col span="12">
          <van-button
            type="info"
            color="#5D6772"
            block
            @click="confirmCancel"
          >确认取消订单</van-button>
        </van-col>
      </van-row>
    </div>
    <!-- 去到底部 -->
    <ShowMore
      ref="showMoreRef"
      wrap-box="top-box"
    />
  </div>
</template>

<script>
import ConfirmDialog from '@/components/confirmDialog.vue';
import CancelReasonSelectBox from '../components/cancelReasonSelectBox.vue';
import WorkOrders from '../components/workOrders.vue';
import Certificate from '../components/certificate.vue';
import ShowMore from '../components/showMore.vue';
import {
  queryDictByCodes
} from '@/common/api.js';
import {
  getTaskDetail,
  checkPictureNum,
  savePictureTemplate,
  getRescueReport
} from '@/common/apiPaic.js';
import {
  contactUserCount,
  cancel
} from '@/common/apiGeneral.js';
import { mapState } from 'vuex';
import { paicProductCode, generalProductCode } from '@/common/constant';

const initDataForm = () => {
  return {
    cancelType: '02',
    cancelReason: {
      code: '',
      desc: '',
      remark: ''
    }
  };
};

export default {
  name: 'GeneralOrderCancelOrder',
  components: {
    ConfirmDialog,
    CancelReasonSelectBox,
    WorkOrders,
    Certificate,
    ShowMore
  },
  data() {
    return {
      dataForm: initDataForm(),
      cancelTypeList: [],
      cancelTypeListBase: [
        {
          key: '02',
          value: '取消无费'
        },
        {
          key: '00',
          value: '取消有费'
        }
      ],
      cancelTypeMap: {
        '02': '取消无费',
        '00': '取消有费'
      },
      reasonDataList: [],
      imageInfo: {},
      fromPage: '',
      orderNo: '',
      taskNo: '',
      useTraceCar: 0,
      pictureTypes: ['010'],
      imageCompleted: false,
      countObj: {},
      productCategoryName: '',
      reportData: {}
    };
  },
  computed: {
    ...mapState('orderGeneral', {
      taskStatus: state => state.taskStatus
    }),
    isCancelFee() {
      return this.dataForm.cancelType === '00';
    },
    // 是否完善
    isPerfection() {
      return this.reportData && this.reportData.operatorSign && this.reportData.carStatus;
    },
    photoParams() {
      return {
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        useTraceCar: this.useTraceCar,
        pictureTypes: this.pictureTypes
      };
    }
  },
  created() {
    const {
      fromPage,
      orderNo,
      taskNo
    } = this.$route.params;
    if (orderNo && taskNo) {
      this.fromPage = fromPage;
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
  },
  mounted() {
    this.getTaskDetail();
    this.queryDictByCodes();
    this.contactUserCount();
  },
  activated() {
    this.checkPictureNum();
    this.getRescueReport();
  },
  methods: {
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.reportData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goWorkOrders() {
      this.$router.push({
        name: 'GeneralOrderWorkOrders',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          isH5: true
        }
      });
    },
    cancelTypeChange() {
      if (this.isCancelFee) {
        this.checkPictureNum();
      }
    },
    toPage(name) {
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      this.$router.replace(router);
    },
    backToWork() {
      // this.toPage(this.fromPage);
      this.$router.go(-1);
    },
    async confirmCancel() {
      if (this.isCancelFee && !this.imageCompleted) {
        this.showImageInfo();
        return;
      }
      if (!this.dataForm.cancelReason.code) {
        this.showRequiredInfo();
        return;
      }
      if (this.$refs.cancelReasonSelectBox) {
        const result = await this.$refs.cancelReasonSelectBox.validate();
        console.log(result);
        if (!result) {
          return;
        }
      }
      console.log(this.dataForm);
      this.showInfoConfirm();
    },
    showImageInfo() {
      const confirmText = this.imageInfo.requiredTips || '图片缺失';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '去拍照',
        confirmCallback: () => {
          this.toPhoto();
        },
        cancelCallback: () => {
        }
      });
    },
    showRequiredInfo() {
      const confirmText = '请选择对应的取消原因';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '确定',
        confirmCallback: () => {
        },
        cancelCallback: () => {
        }
      });
    },
    showInfoConfirm() {
      const confirmObj = [
        {
          key: '类型',
          value: this.productCategoryName
        },
        {
          key: '取消类型',
          value: this.cancelTypeMap[this.dataForm.cancelType]
        }
      ];
      this.$refs.confirmDialog.open({
        confirmObj,
        cancelButtonText: '返回修改',
        confirmButtonText: '确认提交',
        confirmCallback: () => {
          this.savePictureTemplate();
        },
        cancelCallback: () => {
        }
      });
    },
    async contactUserCount() {
      try {
        const res = await contactUserCount({
          taskNo: this.taskNo,
          taskStatus: this.taskStatus
        });
        if (res) {
          this.countObj = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async queryDictByCodes() {
      try {
        const res = await queryDictByCodes({
          codes: [
            'APP_CANCEL_REASON' // 取消原因
          ]
        });
        if (res) {
          this.reasonDataList = res.find(item => item.code === 'APP_CANCEL_REASON').kvs;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          const {
            categoryCode,
            productCategoryName
          } = data;
          this.productCategoryName = productCategoryName;

          if ([paicProductCode.categoryCode_FL10000002, paicProductCode.categoryCode_FL10000003].includes(categoryCode)) {
            this.useTraceCar = 1;
          } else {
            this.useTraceCar = 0;
          }

          if ([generalProductCode.categoryCode_FL90000001].includes(data.categoryParentCode)) {
            // 事故救援
            this.cancelTypeList = [this.cancelTypeListBase[0]];
          } else {
            this.cancelTypeList = this.cancelTypeListBase;
          }
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkPictureNum(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '正在更新图片数据...',
          forbidClick: true
        });
      }
      const params = {
        useTraceCar: this.useTraceCar,
        pictureTypes: this.pictureTypes
      };
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await checkPictureNum({
          orderNo: this.orderNo,
          ...params
        });
        const {
          requiredNum,
          total,
          requiredTips
        } = data || {};
        this.imageCompleted = !isNaN(total) && total === requiredNum;
        this.imageInfo = {
          photoNumTaked: requiredNum,
          photoNumAll: total,
          requiredTips
        };
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async savePictureTemplate(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const params = {
          useTraceCar: this.useTraceCar,
          pictureTypes: this.pictureTypes
        };
        await savePictureTemplate({
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        this.cancel();
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async cancel(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        console.log(this.dataForm);
        await cancel({
          taskNo: this.taskNo,
          cancelType: this.dataForm.cancelType,
          cancelReasonCode: this.dataForm.cancelReason.code,
          cancelReasonDesc: this.dataForm.cancelReason.desc,
          remark: this.dataForm.cancelReason.remark
        });
        this.$refs.confirmDialog.close();
        this.backToWork();
        setTimeout(() => {
          this.toPage('GeneralOrderExecuted');
        }, 100);
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async toPhoto() {
      await this.$nextTick();
      const params = {
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        useTraceCar: this.useTraceCar,
        pictureTypes: this.pictureTypes
      };
      const router = {
        name: 'GeneralOrderCertificate',
        query: {
          photoParams: JSON.stringify(params)
        }
      };
      console.log('router: ', router);
      // this.$router.push(router);
    },
    setCurrentScrollTop() {
      this.$refs.showMoreRef && this.$refs.showMoreRef.setCurrentScrollTop();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box{
  .top-box{
    overflow-y: auto;

    height: calc(100vh - 60px - 46px);

    background: #F2F3F5;
  }
}
.flex-box{
  display: flex;
}
.content-box {
  padding: 12px;

  .card-box{
    border-radius: 8px;
    background: #FFFFFF;

    & + .card-box{
      margin-top: 12px;
    }

    &.card-padding{
      padding: 16px;
    }

    ::v-deep .card-title,
    .card-title{
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;

      &.card-title-flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-title-info{
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon{
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        &.card-tips__red {
          color: #F32222;
        }
      }

    }

    .radio-box{
      padding: 16px 0;

      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      ::v-deep .van-radio{
        &.van-radio--horizontal{
          margin-right: 48px;
        }
        .van-radio__icon{
          font-size: 18px;
          &.van-radio__icon--checked .van-icon{
            border-color: #3399FF;
            background-color: #3399FF;
          }
          .van-icon{
            border: 1px solid rgba(153,153,153,1);
          }
        }
      }
    }

    .remark-box{
      padding: 16px;

      text-align: center;
      letter-spacing: -0.36px;

      border-radius: 9px;
      background: #F2F4F5;

      font-family: PingFangSC-Regular;
      font-size: 14px;
      font-weight: 400;

      .remark-tips{
        color: #F32222;
      }

      .remark-content{
        margin-top: 16px;

        color: #383838;

        .color-orange{
          color: #FF8A59;
        }
      }
    }

    .van-button{
      text-align: center;
      letter-spacing: -0.38px;

      color: #FFFFFF;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info{
        border-color: #3399FF;
        background-color: #3399FF;
      }

      &.van-button--large{
        height: 39px;
      }
    }

    .textarea-box,
    ::v-deep .textarea-box{
      padding: 12px;

      letter-spacing: -0.38px;

      border: 1px solid rgba(200,200,200,1);
      border-radius: 8px;
      background: #FFFFFF;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      ::v-deep .van-field__control{
        color: #383838;

        &::placeholder{
          color: #C8C8C8;
        }
      }
    }
  }
}

.btn-box{
  padding: 10px 16px;

  background: #FFFFFF;
  .van-button{
    height: 40px;
    padding: 9px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    border-radius: 8px;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.van-button--default{
      color: #646464;
      border: 1px solid rgba(200,200,200,1);
      background: #FFFFFF;
    }

    &.van-button--info{
      color: #FFFFFF;
      border: 1px solid #3399FF;
      background: #3399FF;
    }
  }
}
.card-flex{
  display: flex;
  align-items: center;
}
.takeImg{
  width: 35px;
  margin-right: 10px;
}
.stateInfo{
  margin-right: 10px;

  color: #383838;

  font-size: 15px;
  font-weight: 400;
}
.isStateInfo{
  color: #F32222;
}
</style>
